module.exports = "/assets/1eef9471100e7d8496a7a4650834c81c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/JU.png
// module id = 2647
// module chunks = 0